import { Toolbar, Skeleton, Box } from '@mui/material';
import { SkeletonList } from '../../skeleton-list/SkeletonList';
import { desktopHeaderStyles } from './styles';

export const DesktopHeaderSkeleton: React.FC = () => {
  return (
    <Toolbar disableGutters className="container-fluid">
      <Skeleton variant="rectangular" width={100} height={30} />
      <Box sx={desktopHeaderStyles.skeletonMenuList}>
        <SkeletonList variant="text" width={60} itemsCount={4} sx={desktopHeaderStyles.skeletonMenu} />
      </Box>
      <Skeleton variant="circular" width={40} height={40} />
    </Toolbar>
  );
};
